import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryVTC } from "@/strapiQuery/vtc";
import { VTCContent } from "@/components/pages/vtc/VTC";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const vtcContentPromise = getStrapiEntity<VTCContent>("vtc", queryVTC);

  const [layout, vtcContent] = await Promise.all([
    layoutPromise,
    vtcContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...vtcContent,
      intlMessages,
      defaultCanonicalRoute: routes.vtc,
    },
    revalidate: 10,
  };
};

export { VTC as default } from "@/components/pages/vtc/VTC";
